

import { Component } from "vue-property-decorator";
import Axios from "axios";
import stores from "@/store/store";
const store: any = stores;
import { BASE_API_URL } from "@/config";
import { mixins } from "vue-class-component";
import { HollowDotsSpinner } from "epic-spinners";
import DisplayFiles from "@/views/DisplayDocument.vue";
import { BROKER_LOAN_DOCUMENTS_EXTENSION, LOAN_TERM, ALLOWED_FILE_EXTENSIONS } from "@/constants";
import UpdateUserInfo from "@/views/UpdateUserInfo.vue";
import { DTIRadialBar } from "@/views/charts/radial-bar/dti-radial-bar";
import { loanInfo } from "@/models/borrowerData.model";
import SelectBorrowerForPos from "@/views/SelectBorrowerForPos.vue";
import CustomVueNumeric from "@/views/CustomVueNumeric.vue";
import LosRequiredField from "@/views/LosRequiredField.vue";
import DtiAndHousingRatioDetails from "@/views/DtiAndHousingRatioDetails.vue";
import LOSMixin from "@/mixins/los.mixin";
import Multiselect from "vue-multiselect";
import LoanStateWarning from "@/views/LoanStateWarning.vue";
import _ from "lodash";


@Component({
  components: {
    HollowDotsSpinner,
    DisplayFiles,
    UpdateUserInfo,
    SelectBorrowerForPos,
    CustomVueNumeric,
    DtiAndHousingRatioDetails,
    LosRequiredField,
    Multiselect,
    LoanStateWarning,
  }
})
export default class LoanDocuments extends mixins(LOSMixin) {
  public allowedFileExtensions = ALLOWED_FILE_EXTENSIONS;
  public RadialBar: DTIRadialBar;
  public loanInformation: any = new loanInfo();
  public loanTerm = LOAN_TERM;
  public validateDoc: any = {};
  public callOnSubmitToLoan = false;
  public callFromAusFinding = false;
  public callFromBusinessDoc = false;
  public showErrForAusFinding = false;
  public fileCount = 0;
  public isMailSent = false;
  public source = null;
  public personalInfo = [];
  public docExtension: any = BROKER_LOAN_DOCUMENTS_EXTENSION;
  public loanTxnId = null;
  public documentId = null;
  public doc = null;
  public ausFileId = null;
  public docsToUpload: any = [];
  public documentLeftToUpload = [];
  public borrowerDetails: any = null;
  public documents: any = [];
  public areDocumentsLoaded: boolean = false;
  public filesForSlide: any = [];
  public files = [];
  public borrowers = [];
  public borrowerName = [];
  public fileToDisplay = null;
  public displayFileType = null;
  public displayingFileSubCategoryName = null;
  public displayingFileIndex = 0;
  public confirmDeleteFile: any = null;
  public newSubCategory = null;
  public isNewSubCatEmpty = false;
  public isNewCategoryEmpty = false;
  public newCategory = null;
  public isBorrowerSelected = true;
  public isCategoryFixed = false;
  public checkDocumentExt = false;
  public docFiles: any = null;
  public docId = null;
  public errorInComment = false;
  public hasAppraisal = false;
  public isActiveOrderTitle = false;
  public hasLessThanLoanAmount = false;
  public hasGreaterRate = false;
  public isDelete = false;
  public isSubmit = false;
  public hasDocumentLeftToUpload = false;
  public showValidation = false;
  public brokerProfilePicture = null;
  public orderTitleRequest: any = {
    companyName: "",
    email: "",
    phone: "",
    address: "",
    uploadedOn: new Date()
  };
  public loader1: any = [];
  public loader2: any = [];
  public loader3: any = [];
  public loader4: any = [];
  public loader5: any = [];
  public errorMsg = false;
  public warningClearedToSubmit: boolean = false;
  public isMandatoryBrokerOnboarding: boolean = false;
  //================================================================================================
  public hideSubmit: boolean = null;
  //================================================================================================
  public taskOption = null;
  public hasEscrow = null;
  public notVoeNumber = false;
  public errorComment = false;
  public showButton = false;
  public checkDocHasUploaded = true;
  public comment = null;
  public moveToLead: boolean = true;
  public borrowerData: any = null;
  /** selection of Borrower for POS */
  // public openBorrowerSelectionModal = false;

  public losRequiredList = null;
  public isLosFieldMissing = false;
  public urlSource: string = null;
  public isEmailVerified = false;
  public dtiAndHousingRatioDetails: any = null;
  public currentEnvironment = null;
  public hasStateLicense: boolean = true;

  /****************************************************************************************************************************
   *fetch (borrowerInfo collection personalInfo object for all borrower's , loanAndProperty collection propertyAddress object)*
   *                                and (DTI Ratio, HousingRatio)                                                             *
   ****************************************************************************************************************************/

  public ShowDtiValue = false;

  public setHasStateLicense(hasStateLicense) {
    this.hasStateLicense = hasStateLicense;
  }
  
  /**
   * Skip fields and documents validation
   */
  public skipUrlaValidation = false;
  public skipUrlaSubmission = false;

  public async fetchBorrwoerInfo() {
    try {
      this.$store.state.wemloLoader = true;
      let response = await Axios.post(
        BASE_API_URL + "loan/getBorrowerInfo",
        { loanTxnId: this.loanTxnId }
      );
      
      if (response.status == 200) {
        this.borrowerData = response.data;
      }

      this.isEmailVerified = this.borrowerData.isEmailVerified; //Checking borrower isEmailVerified.
      if (this.hasEdit()) {
        this.RadialBar = new DTIRadialBar(
          this.borrowerData.dtiRatio,
          this.borrowerData.housingRatio,
          "radialBar"
        );
      }
      this.urlSource = this.borrowerData.source;
      this.moveToLead = response.data.moveToLead;
      this.$store.state.wemloLoader = false;
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error);
    }
  }

  get state() {
    const isPropertyTBD = !!_.get(this.borrowerData, '.loanAndProperty.toBeDecidedProperty', false);

    if (isPropertyTBD) { return null; }

    return _.get(this.borrowerData, 'loanAndProperty.propertyAddress.address.state');
  }

  /**
   *  Function to automate file upload for local dev testing
   */
  public async automateFileUploadForDev(event){
    const docFiles = event.target.files;
    const documents = this.documents;

    for (let i = 0; i < documents.length; i++){ 
      const document = documents[i];

      if (document.fileHistory && document.fileHistory.length && document.fileHistory[document.fileHistory.length - 1].status == 'Uploaded') { continue; }

      await this.uploadFile("skip", docFiles, document._id, document.borrowerId);
    }
  }

  public updateBorrowerInfo(updatedData) {
    updatedData.forEach((element, index) => {
      this.borrowerData.borrowerInfo[index].contactInformation.email =
        element.email;
      this.borrowerData.borrowerInfo[index].contactInformation.cellPhone =
        element.cellPhone;
      this.borrowerData.borrowerInfo[index].name.firstName = element.firstName;
      this.borrowerData.borrowerInfo[index].name.lastName = element.lastName;
    });
  }

  public async updateBorrowerInfoData(data) {
    this.borrowerData.borrowerInfo[0].contactInformation.email =
      data.borrowerInfo[0].personalInfo.contactInformation.email;
    this.borrowerData.borrowerInfo[0].contactInformation.cellPhone =
      data.borrowerInfo[0].personalInfo.contactInformation.cellPhone;
    this.borrowerData.borrowerInfo[0].name.firstName =
      data.borrowerInfo[0].personalInfo.name.firstName;
    this.borrowerData.borrowerInfo[0].name.lastName =
      data.borrowerInfo[0].personalInfo.name.lastName;
  }
  /*************************************************************************************************************************
   *                              In that we get Co- name for Borrower                                             *
   *                               Used only for Primary Borrower(zero index).                                             *
   *************************************************************************************************************************/
  public getCoBorrower() {
    try {
      let mapping = this.borrowerDetails.relationshipMapping.find(
        a => a.borrowerIndex == this.borrowerDetails.primaryBorrowerIndex
      );
      if (mapping) {
        if (mapping.coBorrowerIndex.length > 0) {
          let firstName = this.borrowerData.borrowerInfo[
            mapping.coBorrowerIndex[0]
          ].name.firstName;
          let lastName = this.borrowerData.borrowerInfo[
            mapping.coBorrowerIndex[0]
          ].name.lastName;
          return firstName + " " + lastName;
        }
      }
      return "-";
    } catch (error) {
      console.log(error);
    }
  }

  public async showPersonalDetailModal(modalName) {
    try {
      this.personalInfo = [];
      this.borrowerData.borrowerInfo.forEach(borrower => {
        let data = {
          email: borrower.contactInformation.email,
          userId: borrower.userId,
          loanTxnId: this.loanTxnId,
          cellPhone: borrower.contactInformation.cellPhone,
          firstName: borrower.name.firstName,
          lastName: borrower.name.lastName,
          userType: "Borrower",
          modalName: modalName
        };
        this.personalInfo.push(data);
      });

      this.$refs.updateUserStatus["openModalOrClose"](this.personalInfo);
    } catch (error) {}
  }

  /**************************************************************************************************
   *                     When Click on the {Send Invite} button                                     *
   **************************************************************************************************/
  public async sendBorrowerPortal() {
    try {
      let hasMailSent = false;
      this.$store.state.wemloLoader = true;
      let response = await Axios.post(
        BASE_API_URL + "borrower/getCheckBoxInfo",
        {
          loanTxnId: this.loanTxnId
        });
      if (response.data.msg == "success") {
        hasMailSent = true;
        this.isMailSent = true;
        this.$store.state.wemloLoader = false;
        this.$snotify.success("Invitation Sent successfully");
      } else {
        this.$store.state.wemloLoader = false;
        this.$snotify.error("Invitation Not Sent, Please try again");
      }
      // await this.getBorrowersDocumentsDetails();
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error);
    }
  }

  public async deleteLoan() {
    try {
      this.$store.state.wemloLoader = true;
      let response = await Axios.post(
        BASE_API_URL + "loan/deleteLoan",
        { loanTxnId: this.loanTxnId });
      this.$snotify.success(response.data.message);
      this.$router.push({ path: this.$getCurrentUserTypePath("dashboard") });
      this.$store.state.wemloLoader = false;
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error);
    }
  }

  public async getBrokerDetails() {
    try {
      this.$store.state.wemloLoader = true;
      let response = await Axios.get(BASE_API_URL + "broker/getBrokerDetails", {
        params: { brokerId: this.$brokerId }
      });
      this.brokerProfilePicture = response.data.brokerDetail.profilePicture;
      this.warningClearedToSubmit = this.isMandatoryBrokerOnboarding ? (!response.data.brokerDetail.clearedToSubmit || false) : false;
      this.$store.state.wemloLoader = false;
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error.response);
    }
  }

  public async getPreQualLetter() {
    try {
      if (
        this.borrowerDetails &&
        this.borrowerDetails.loanInformation.propertyValue != 0
      ) {
        if (this.brokerProfilePicture != null) {
          this.$router.push({
            path: this.$getCurrentUserTypePath("pre-qualification"),
            query: { loanTxnId: this.loanTxnId }
          });
        } else {
          this.$snotify.info("Please upload logo to generate Pre-Qual letter");
        }
      } else {
        this.$snotify.info("Price is required");
      }
    } catch (error) {
      console.log(error);
    }
  }

  public async getBorrowersDocumentsDetails() {
    try {
      this.$store.state.wemloLoader = true;
      let response = await Axios.get(
        BASE_API_URL + "broker/getBorrowersDocumentsDetails/" + this.loanTxnId);
      if (response.data.borrower.sendEmail) this.isMailSent = true;
      // this.documents = response.data.documents.filter(
      //   doc => doc.categoryName != "Loan Estimate"
      // );
      this.borrowerDetails = response.data.borrower;
      this.currentEnvironment = response.data.env;
      /********************************************************** 
       *      Don't Remove this code 
      //To disable import 3.2 button if fnm is already uploaded
      // if (this.hasEdit()) {
      //   let button: any = document.getElementById("import");
      //   if (this.borrowerDetails.ediFile) button.disabled = true;
      // }
       **********************************************************/

      this.loanInformation = this.borrowerDetails.loanInformation;
      // if (
      //   (this.borrowerDetails.source == null ||
      //     this.borrowerDetails.source == "wemlo") &&
      //   this.borrowerDetails.ediFile == null
      // ) {
      //   this.hideSubmit = true;
      // } else if (
      //   (this.borrowerDetails.source == "skipPricing" ||
      //     this.borrowerDetails.source == "otherLender") &&
      //   this.borrowerDetails.ediFile == null
      // ) {
      //   this.hideSubmit = true;
      // } else {
      //   this.hideSubmit = false;
      // }
      /**
       * sprint 6
       */
      let inProgressLoan = this.checkLoanIsInProgress(
        response.data.borrower.activeLoanStatus
      );
      if (!inProgressLoan) {
        this.showButton = false;
      } else {
        this.showButton = true;
      }
      // this.moveToLead = response.data.borrower.moveToLead;
      this.setLoaderValues();
      this.$store.state.wemloLoader = false;
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error);
    }
  }

  public async getBorrowerLoanDocuments() {
    this.areDocumentsLoaded = false;
    try {
      let response = await Axios.post(
        BASE_API_URL + "document/fetchBorrowerDocuments/",
        { loanTxnId: this.loanTxnId });
      this.documents = response.data.documents;
      this.ausFileId = response.data.ausFinding;
      this.areDocumentsLoaded = true;
    } catch (error) {}
  }
  public conditionOfShowingButton() {
    if ((this.hasEdit() && !this.showButton) || this.moveToLead) {
      return true;
    } else return false;
  }
  public checkLoanIsInProgress(activeLoanStatus) {
    if (
      activeLoanStatus &&
      activeLoanStatus.statusId != 1 &&
      activeLoanStatus.statusId != 2 &&
      activeLoanStatus.statusId != 4
    )
      return true;
    else return false;
  }
  public setLoaderValues() {
    let docs = this.documents;
    docs.forEach((d, i) => {
      if (d.categoryType == "Income Documents") {
        this.loader1.push(false);
      }
      if (d.categoryType == "Assets") {
        this.loader2.push(false);
      }
      if (d.categoryType == "Property") {
        this.loader3.push(false);
      }
      if (d.categoryType == "Identification") {
        this.loader4.push(false);
      }
      if (d.categoryType == "Miscellaneous") {
        this.loader5.push(false);
      }
    });
  }

  public hasEdit() {
    return this.$route.query.edit ? true : false;
  }

  public async checkAusFindingUploadedOrNot(id, doc, status) {
    this.doc = doc;
    let categoryName = doc.documentYear
      ? doc.categoryName.replace(doc.documentYear, "").trim()
      : doc.categoryName;
    let hasAusFinding = this.ausFileId.fileHistory.length > 0 ? true : false;
    if (
      categoryName == "IRS Form 1040 (Individual Tax Return)" ||
      categoryName.includes("IRS Form 1040 (Individual Tax Return)") ||
      categoryName.includes("IRS Form 1120 (Business Tax Return)")
    ) {
      this.callFromBusinessDoc = true;
      await this.updateDocumentStatus("NA", id, status);
    } else {
      if (categoryName.includes("Home Owners Insurance")) {
        this.callFromBusinessDoc = true;
        this.$modal.show("escrowModal");
      } else {
        if (hasAusFinding) this.$modal.show("NACommentPopup");
        else {
          this.$modal.show("uploadAusFinding");
          this.callFromAusFinding = true;
        }
      }
    }
  }

  public async toggleRadioButton(id, doc, status) {
    if (status == "Not Applicable") {
      if (doc.documentStatus == "Required") {
        await this.checkAusFindingUploadedOrNot(id, doc, status);
      }
      // else if(doc.documentStatus=='Wemlo Assitance'){
      // await this.checkAusFindingUploadedOrNot(id,doc,status);
      // }
      else if (doc.documentStatus == "Uploaded")
        await this.checkAusFindingUploadedOrNot(id, doc, status);
      else await this.updateDocumentStatus("NA", id, "Required");
    }
    // else if(status=='Wemlo Assitance'){
    //   if(doc.documentStatus=='Required')
    //   await this.updateDocumentStatus('WA',id,'Wemlo Assitance')
    //    else if(doc.documentStatus=='Not Applicable')
    //   await this.updateDocumentStatus('NA',id,status)
    //   else
    //   await this.updateDocumentStatus('WA',id,'Required')
    // }
  }

  public async updateDocumentStatus(type, id, status) {
    try {
      let valid = await this.$validator.validateAll();
      if (!valid) return;
      if (type == "NA") {
        if (!this.callFromBusinessDoc) {
          this.comment == null || this.comment == ""
            ? (this.errorInComment = true)
            : (this.errorInComment = false);
          if (this.errorInComment) return;
        }
        this.$store.state.wemloLoader = true;
        let response = await Axios.post(
          BASE_API_URL + "document/MarkDocumentAsNotApplicable",
          {
            loanTxnId: this.loanTxnId,
            documentId: id,
            status: status,
            comment: this.comment,
            hasEscrow: this.hasEscrow
          });
      } else {
        let response = await Axios.post(
          BASE_API_URL + "document/MarkDocumentAsBorrowerToUpload",
          {
            loanTxnId: this.loanTxnId,
            documentId: id,
            status: status
          });
      }
      this.comment = null;
      this.hasEscrow = null;
      this.errorInComment = false;
      this.callFromAusFinding = false;
      this.$modal.hide("NACommentPopup");
      this.$modal.hide("uploadAusFinding");
      this.$modal.hide("escrowModal");
      await this.getBorrowerLoanDocuments();
      if (this.callOnSubmitToLoan) this.validateDocuments();
    } catch (error) {
      console.log(error);
    }
    this.$store.state.wemloLoader = false;
  }

  public categoryHasDocuments(catName) {
    let docs = this.documents.filter(uploadedDoc => {
      if (
        uploadedDoc.categoryType == catName &&
        uploadedDoc.categoryName != "AUS Finding" &&
        uploadedDoc.fileHistory.length > 0 &&
        uploadedDoc.fileHistory[uploadedDoc.fileHistory.length - 1].files
          .length > 0
      ) {
        return uploadedDoc;
      }
    });
    return docs.length > 0 ? true : false;
  }

  public checkCategoryHasDocs(categoryType) {
    let docs = this.documents.filter(doc => doc.categoryType == categoryType);
    return docs.length > 0 ? true : false;
  }

  public checkDocumentHasUploaded(doc) {
    let returnData = false;
    if (doc.documentStatus != "Not Applicable") {
      if (doc.fileHistory.length > 0) {
        if (doc.fileHistory[doc.fileHistory.length - 1].status == "Rejected") {
          returnData = true;
        } else returnData = false;
      } else {
        returnData = true;
      }
    }
    return returnData;
  }

  public checkDocumentHasApproved(doc) {
    let returnData = false;
    if (doc.documentStatus != "Not Applicable") {
      if (doc.fileHistory.length > 0) {
        if (doc.fileHistory[doc.fileHistory.length - 1].status == "Approved") {
          returnData = true;
        }
      } else {
        returnData = true;
      }
    }
    return returnData;
  }

  public fileExtension(fileName) {
    let ext = fileName.substr(fileName.lastIndexOf(".") + 1);
    return ext.toLowerCase();
  }

  public async setFIleToDisplay(action = null) {
    if (
      action == "next" &&
      this.displayingFileIndex < this.filesForSlide.length - 1
    ) {
      this.displayingFileIndex++;
    } else if (action == "previous" && this.displayingFileIndex > 0) {
      this.displayingFileIndex--;
    }
    if (this.displayingFileIndex >= this.filesForSlide.length) {
      this.displayingFileIndex--;
    }

    this.fileToDisplay =
      this.filesForSlide[this.displayingFileIndex];
    let ext = await this.fileExtension(this.fileToDisplay);
    this.displayFileType = ext.toLowerCase();
  }

  public async loadFilesForSlide(doc, conditionType, id) {
    let display = doc.fileHistory[doc.fileHistory.length - 1].files;
    let showDeleteButton = null;
    if (!this.checkFileHasRejectedOrApporoved(doc)) {
      showDeleteButton = true;
    } else {
      showDeleteButton = false;
    }
    this.$refs.dfl["setInitialValuesForShowingSamplesWithDeleteButton"](
      display,
      showDeleteButton,
      { docId: id },
      doc,
      conditionType,
      "loanDocument"
    );
  }

  /**************************************************************************************************
   *              FOR DELETING THE FILES FROM FILE HISTORY (FILES)      don't remove                *
   **************************************************************************************************/
  // public async removeFile() {
  //   try {
  //     let file = this.filesForSlide[this.displayingFileIndex].path;
  //     let response = await Axios.post(
  //       BASE_API_URL + "pos/removeLoanDocumentFile",
  //       {
  //         loanTxnId: this.loanTxnId,
  //         id: this.displayingFileId,
  //         file: file,
  //         fileIndex: this.displayingFileIndex
  //       },
  //       {
  //
  //       }
  //     );
  //     this.confirmDeleteFile = false;
  //     this.documents = response.data;
  //     this.filesForSlide = this.filesForSlide.filter(
  //       (e, i) => e != file && i != this.displayingFileIndex
  //     );
  //     if (this.filesForSlide.length > 0) {
  //       this.setFIleToDisplay();
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  public async insertNewCategoryAndSubcategory() {
    this.$store.state.wemloLoader = true;
    try {
      if (!this.newCategory) {
        this.isNewCategoryEmpty = true;
        this.$store.state.wemloLoader = false;
        return;
      } else if (!this.newSubCategory || this.borrowerName.length == 0) {
        if (!this.newSubCategory) this.isNewSubCatEmpty = true;
        if (this.borrowerName.length == 0) this.isBorrowerSelected = false;
        this.$store.state.wemloLoader = false;
        return;
      }
      let response = await Axios.post(
        BASE_API_URL + "pos/addNewDocumentCategory",
        {
          loanTxnId: this.loanTxnId,
          category: this.newCategory,
          subCategory: this.newSubCategory,
          borrowers: this.borrowerName
        });
      await this.getBorrowerLoanDocuments();
      this.hideNewCategoryModal();
    } catch (error) {
      console.log(error);
    }
    this.$store.state.wemloLoader = false;
  }

  public hideNewCategoryModal() {
    this.$modal.hide("newCategoryModal");
    this.newCategory = null;
    this.newSubCategory = null;
    this.isCategoryFixed = false;
    this.borrowerName = [];
    this.borrowers = [];
    this.isBorrowerSelected = true;
    this.isNewSubCatEmpty = false
    this.isNewCategoryEmpty = false
  }

  public async sendMailToSuperAdmin() {
    try {
      let response = await Axios.post(
        BASE_API_URL + "pos/sendMailToSuperAdmin",
        {
          loanTxnId: this.loanTxnId
        });
    } catch (error) {}
  }

  /**************************************************************************************************
   *                                    IF DOCUMENT NOT LOADED THEN                                  *
   **************************************************************************************************/
  public ifDocumentNotLoad(time: number) {
    try {
      setTimeout(() => {
        let checkLoader = document.getElementById("checkLoader");
        if (checkLoader != null) {
          let iframe: any = document.getElementById("checkElement");
          if (iframe.localName == "iframe") {
            iframe.src =
              "https://docs.google.com/gview?url=" +
              this.fileToDisplay +
              "&embedded=true";
          } else {
            iframe.src = this.fileToDisplay;
          }
          this.ifDocumentNotLoad(time + 1000);
        }
      }, time);
    } catch (error) {
      console.log(error);
    }
  }

  // public downloadFile(file) {
  //   window.open(file);
  // }

  /**************************************************************************************************
   *                                       TO SHOW THREE THE FILE HISTORY                            *
   **************************************************************************************************/
  public showThreeFileHistory(fileHistory) {
    let length = fileHistory.length;
    if (length > 3) {
      return fileHistory.slice(length - 3, length);
    }
    return fileHistory;
  }

  /*****************************************************************************************************
   *              filter Documents Based on CategoryType                                               *
   *****************************************************************************************************/
  public filterDocumentsByCategoryType(categoryType, type) {
    if (type == "uploaded") {
      let uploadedDoc = this.documents.filter(
        doc => doc.categoryType == categoryType && doc.fileHistory.length > 0
      );
      return uploadedDoc;
    } else if (type == "borToUpload") {
      let borToUpload = this.documents.filter(
        doc =>
          doc.categoryType == categoryType &&
          // doc.documentStatus == "Wemlo Assitance" &&
          doc.fileHistory.length == 0
      );
      return borToUpload;
    } else {
      let NADoc = this.documents.filter(
        doc =>
          doc.categoryType == categoryType &&
          doc.documentStatus == "Not Applicable" &&
          doc.fileHistory.length == 0
      );
      return NADoc;
    }
  }

  /*****************************************************************************************************
   *                filter property Documents Based on CategoryName                                    *
   *****************************************************************************************************/
  public filterPropertyDocuments(categoryName, type) {
    if (type == "uploaded") {
      let uploadedDoc = this.documents.filter(
        doc =>
          doc.categoryType == "Property" &&
          doc.categoryName == categoryName &&
          doc.fileHistory.length > 0 &&
          doc.documentStatus != "Not Applicable"
      );
      return uploadedDoc;
    } else if (type == "borToUpload") {
      let borToUpload = this.documents.filter(
        doc =>
          doc.categoryType == "Property" &&
          doc.categoryName == categoryName &&
          doc.documentStatus == "Not Applicable" &&
          doc.fileHistory.length == 0
      );
      return borToUpload;
    } else {
      let NaDoc = this.documents.filter(
        doc =>
          doc.categoryType == "Property" &&
          doc.categoryName == categoryName &&
          // doc.documentStatus == "Wemlo Assitance" &&
          doc.fileHistory.length == 0
      );
      return NaDoc;
    }
  }

  // public removeValidation() {
  //   try {
  //     this.validateDoc = {};
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  /****************************************************************************************
   *            Checking required field in 1003 form                                      *
   *                                                                                      *
   ****************************************************************************************/
  public async checkLosFormCompleted() {
    try {
      let response = await Axios.post(
        BASE_API_URL + "loan/checkLosFormCompleted",
        { loanTxnId: this.loanTxnId });

      /**
       * Skip urla validation of required fields and required documents
       */
      this.skipUrlaValidation = response.data.skipUrlaValidation;
      this.skipUrlaSubmission = response.data.skipUrlaSubmission;

      if (response.data.status == "error") {
        return response.data.errorList;
      }
    } catch (error) {
      console.log(error);
    }
  }

  public async checkIfDocumentsLeftToSubmit(){
     let valid = await this.$validator.validateAll();
      this.hasDocumentLeftToUpload = this.validateDocuments();
      if (this.hasDocumentLeftToUpload || !valid) {
        return true;
      }
      return false;
  }

  public gotoSubmissionForm() {
    this.$router.push({
      path: this.$getCurrentUserTypePath("submission-form"),
      query: {
        id: this.loanTxnId,
        edit: "true",
      },
    });
  }

  get isSubmitBtnDisabled() {
    return !this.areDocumentsLoaded || this.warningClearedToSubmit;
  }

  /**
   * If Save Lead is clicked then we are saving the status Prospect
   */
  public async submitToWemlo(type) {
    try {

      if (type == "submit") {
        this.hasDocumentLeftToUpload = this.validateDocuments();

        if(this.hasDocumentLeftToUpload) {
          this.showRequiredDocumentsList();
          return;
        }

        this.losRequiredList = await this.checkLosFormCompleted();

        if (this.losRequiredList) {
          this.isLosFieldMissing = true;
          return;
        }

      }

      let valid = await this.$validator.validateAll();
      let body = null;
      if (type == "saveLead") {
        // if (!valid) {
        //   return;
        // }
        body = {
          loanTxnId: this.loanTxnId,
          loanInformation: this.loanInformation,
          type: type
        };
      } else {
        let documents = this.documents;
        this.callOnSubmitToLoan = true;
        this.hasDocumentLeftToUpload = this.validateDocuments();
        if (this.hasDocumentLeftToUpload || !valid) {
          this.showValidation = true;
          return;
        }
        this.showValidation = false;
        if (this.$route.query.edit) {
          let validLoanAmount = await this.$refs.amount["validateAll"]();
          let validInterestRate = await this.$refs.rate["validateAll"]();
          let validPrice = await this.$refs.price["validateAll"]();
          // if (
          //   !validLoanAmount ||
          //   !validInterestRate ||
          //   !validPrice ||
          //   this.hasLessThanLoanAmount ||
          //   this.hasGreaterRate
          // )
          //   return;
        }

        body = {
          loanTxnId: this.loanTxnId,
          userType: this.$userType,
          type: type,
          brokerId: this.$brokerId,
          loanInformation: this.loanInformation
        };
      }
      this.$store.state.wemloLoader = true;
      let response = await Axios.post(
        BASE_API_URL + "broker/saveLoanStatus",
        body);
      this.$store.state.wemloLoader = false;
      if (this.moveToLead) {
        this.updateMoveToLead();
        return;
      }
      if (!this.moveToLead) {
        if (response.data.message == "saveLead") {
          if (!this.hasEdit()) {
            this.$router.push({
              path: this.$getCurrentUserTypePath("blank-backGround-popUp"),
              query: {
                id: this.$route.query.id,
                modalName: "savelead",
                source: "Documents Upload & Request "
              }
            });
          } else {
            this.$router.push({
              path: this.$getCurrentUserTypePath("dashboard")
            });
          }
        } else if (response.data.message == "Success") {
          // Check Sbmit to Wemlo Button Have Enable Or Not
          let isActiveSubmitToWemlo = await this.checkSubmitToWemloButtonHaveActive();
          if (!isActiveSubmitToWemlo) {
            this.$modal.show("SubmitToWemloWarningCountDownModal");
            return;
          }
          this.$router.push({
            path: this.$getCurrentUserTypePath("submission-form"),
            query: { id: this.loanTxnId, edit: "true" }
          });
        }
      }
      // this.sendMailToSuperAdmin();
      this.$store.state.wemloLoader = false;
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error);
    }
  }

  public async forceSubmitToWemlo() {
    try {
      let confirmSubmission = false;

      await this.$dialog
        .confirm("Are you sure you want to submit?")
        .then(() => {
          confirmSubmission = true;
        })
        .catch(() => {
          confirmSubmission = false;
        });

      if (!confirmSubmission) {
        return;
      }

      let response = await Axios.post(BASE_API_URL + "broker/forceSubmitToWemlo", {
        loanTxnId: this.loanTxnId,
        userId: this.$userId,
        userType: this.$userType,
      });

      this.$router.push(response.data.redirectTo);
      this.$snotify.success(response.data.message);
    } catch (error) {
      console.log(error);
    }
  }

  // To change the status of moveToLead when clicked on the button MoveToLead on processor side
  //so that after inprocessing loan can move to leads
  public async updateMoveToLead() {
    try {
      this.$store.state.wemloLoader = true;
      let response = await Axios.post(
        BASE_API_URL + "broker/updateMoveToLead",
        {
          loanTxnId: this.loanTxnId,
          moveToLead: this.moveToLead,
          userType: this.$userType
        });
      this.$store.state.wemloLoader = false;
      this.$snotify.success("Data Saved Successfully");
      this.$router.push({ path: this.$getCurrentUserTypePath("dashboard") });
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error);
    }
  }

  public async checkApprisalOrdered(taskOption) {
    let formValid = await this.$validator.validateAll();
    if (!this.comment) {
      this.errorComment = true;
      return;
    }
    if (!formValid) {
      if (!this.hasAppraisal) return;
    }
    if (
      taskOption == "appraisalWaiver" ||
      taskOption == "appraisalExcemption"
    ) {
      this.$modal.hide("creditAuthorizationModel");
      this.$modal.show("appraisalOrderTask");
    } else if (taskOption == "appraisalOrdered") {
      // await this.submitCreditAuthorization();
    }
  }

  /**************************************************************************************************
   *                         ON MARKING AS NA TO CREDIT AUTHORIZATION                               *
   **************************************************************************************************/
  // public async submitCreditAuthorization() {
  //   try {
  //     this.isSubmit = true;
  //     let body = {
  //       loanTxnId: this.loanTxnId,
  //       taskOption: this.taskOption,
  //       notVoeNumber: this.notVoeNumber,
  //       comment: this.comment
  //     };
  //     this.errorComment = false;
  //     let response = await Axios.post(
  //       BASE_API_URL + "additionalTask/submitCreditAuthorization",
  //       body,
  ////     );
  //     this.isSubmit = false;
  //     if (response.data == "Success") {
  //       let doc = this.documents.filter(
  //         d => d.categoryName == "Credit Card Authorization"
  //       );
  //       doc = doc[0];
  //       this.comment = null;
  //       // await this.updateDocumentStatus(doc._id, "Not Applicable");
  //       this.$modal.hide("creditAuthorizationModel");
  //       this.$snotify.success("Data saved successfully");
  //       await this.getBorrowersDocumentsDetails();
  //       // if (this.callOnSubmitToLoan) this.validateLoanNADocs();
  //     }
  //     this.$modal.hide("appraisalOrderTask");
  //   } catch (error) {
  //     this.isSubmit = false;
  //     console.log(error);
  //   }
  // }
  public viewAusFinding() {
    let files = [];
    Object.values(this.files).forEach(e => {
      files.push(e);
    });
    this.$refs.dfl["setInitialValuesForLocalFiles"](files, false, "files");
  }

  public dragFile(e, docId, type = null, borrowerId) {
    let droppedDocuments = e.dataTransfer.files;
    this.files = droppedDocuments;
    if (!droppedDocuments) {
      return;
    }
    let documentExtension: any = this.getDocumentExtension(droppedDocuments);
    this.checkDocumentExt = true;
    documentExtension.forEach(e => {
      this.docExtension.forEach((element, i) => {
        if (e == element.fileExt) {
          this.checkDocumentExt = false;
        }
      });
    });
    if (this.checkDocumentExt) {
      this.$modal.show("validationErrorMsgModal");
      return;
    }
    if (!type) this.uploadFile("skip", droppedDocuments, docId, borrowerId);
  }

  public attachFile(event, docId, type = null, borrowerId) {
    if (event.target.files.length == 0) {
      return;
    }
    let docFiles = event.target.files;
    this.files = docFiles;
    this.fileCount = this.files.length;
    let documentExtension: any = this.getDocumentExtension(docFiles);
    this.checkDocumentExt = true;
    documentExtension.forEach(e => {
      this.docExtension.forEach((element, i) => {
        if (e == element.fileExt) {
          this.checkDocumentExt = false;
        }
      });
    });
    if (this.checkDocumentExt) {
      this.$modal.show("validationErrorMsgModal");
      return;
    }
    if (!type) this.uploadFile("skip", docFiles, docId, borrowerId);
  }

  public getDocumentExtension(file) {
    let documentExtension = [];
    let documentName = [];
    Object.values(file).forEach((e: any) => {
      documentName.push(e.name);
    });
    documentName.forEach(name => {
      if (name.lastIndexOf(".") != 0) {
        documentExtension.push(name.substring(name.lastIndexOf(".") + 1));
      }
    });
    return documentExtension;
  }

  public async uploadFile(action, files, id, borrowerId) {
    try {
      this.docFiles = files;
      this.docId = id;
      if (this.docFiles.length == 0) {
        this.showErrForAusFinding = true;
        return;
      }
      this.showErrForAusFinding = false;
      if (this.callFromAusFinding)
        this.comment == null || this.comment == ""
          ? (this.errorInComment = true)
          : (this.errorInComment = false);
      if (this.errorInComment) return;
      this.$store.state.wemloLoader = true;
      let formData = new FormData();
      Object.keys(this.docFiles).forEach((e, i) => {
        formData.append("file", this.docFiles[i]);
      });
      formData.append("id", this.docId);
      formData.append("loanTxnId", this.loanTxnId);
      formData.append("userId", this.$userId);
      formData.append("action", action);
      formData.append("borrowerUserId", borrowerId);
      await Axios.post(
        BASE_API_URL + "pos/uploadLoanDocument",
        formData);
      if (this.callFromAusFinding) {
        await this.updateDocumentStatus("NA", this.doc._id, "Not Applicable");
      }

      this.getBorrowerLoanDocuments();

      if (this.callOnSubmitToLoan) {
        this.validateDocuments();
      }
      
      this.checkDocHasUploaded = false;
      this.docFiles = [];
      this.docId = null;
      this.checkDocumentExt = false;
      this.errorInComment = false;
      this.fileCount = 0;
      this.$snotify.success("file uploaded successfully");
      this.$store.state.wemloLoader = false;
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error);
    }
  }

  public checkFileHasRejectedOrApporoved(doc) {
    let returnStatus = false;
    if (doc.documentStatus != "Not Applicable") {
      if (
        doc.fileHistory.length > 0 &&
        (doc.fileHistory[doc.fileHistory.length - 1].status == "Rejected" ||
          doc.fileHistory[doc.fileHistory.length - 1].status == "Approved")
      ) {
        returnStatus = true;
      }
    }
    return returnStatus;
  }

  public openConfirmationModal(fileHistory, subCategory, id) {
    this.displayingFileSubCategoryName = subCategory;
    this.documentId = id;
    this.$modal.show("confirmDeleteFileModal");
  }

  public deleteDocumentData() {
    this.isDelete = true;
    let body = {
      loanTxnId: this.loanTxnId,
      identifier: "deleteDocument",
      id: this.documentId
    };
    return body;
  }

  public deleteFileData(from) {
    let index = 0;
    let documents = this.documents;
    let doc = documents.filter(e => e._id == from.deleteData.docId);
    doc[0].fileHistory[doc[0].fileHistory.length - 1].files.forEach(
      (file, i) => {
        if (file.path == from.files) {
          index = i;
        }
      }
    );
    let file = from.files;
    let body = {
      loanTxnId: this.loanTxnId,
      id: from.deleteData.docId,
      file: file,
      fileIndex: index,
      identifier: "deleteFile"
    };
    return body;
  }

  public async deleteFile(from) {
    try {
      let body = null;
      if (from != null) body = this.deleteFileData(from);
      else body = this.deleteDocumentData();

      let response = await Axios.post(
        BASE_API_URL + "pos/removeLoanDocumentFile",
        body);
      if (response.data.identifier == "deleteDocument") {
        this.$modal.hide("confirmDeleteFileModal");
        this.$snotify.success("Document deleted successfully");
        this.isDelete = false;
      }
      // this.documents = response.data.data;
      this.getBorrowerLoanDocuments();
      if (this.callOnSubmitToLoan) this.validateDocuments();
    } catch (error) {
      this.isDelete = false;
      console.log(error);
    }
  }

  public closeCreditAuthModal() {
    let identificationDoc = this.documents.filter(
      doc =>
        doc.categoryType == "Identification" &&
        doc.documentStatus == "Not Applicable" &&
        // doc.documentStatus == "Wemlo Assitance")
        doc.categoryName == "Credit Card Authorization"
    );
    if (this.callOnSubmitToLoan) {
      if (identificationDoc.length == 1)
        this.validateDoc.validateCreditAuth = false;
      else this.validateDoc.validateCreditAuth = true;
    }
    this.$modal.hide("creditAuthorizationModel");
    this.comment = null;
    this.docFiles = null;
    this.taskOption = null;
    this.errorComment = false;
  }

  public async calculator() {
    this.hasLessThanLoanAmount =
      this.loanInformation.propertyValue < this.loanInformation.loanAmount
        ? true
        : false;
    this.hasGreaterRate =
      this.loanInformation.interestRate > 100 ? true : false;
    if (this.hasLessThanLoanAmount || this.hasGreaterRate) return;
    let interestRate = this.loanInformation.interestRate;
    let loanAmount: any = parseFloat(this.loanInformation.loanAmount);
    let termMonth = this.loanInformation.term
      ? this.loanInformation.term.value
      : null;
    if (
      this.loanInformation.productType &&
      (this.loanInformation.productType.ediValue == "03" ||
        this.loanInformation.productType.ediValue == "02")
    ) {
      let data = {
        mortgageAppliedFor: this.loanInformation.productType,
        purchasePrice: this.loanInformation.propertyValue,
        loanAmount: this.loanInformation.loanAmount,
        loanPurpose: this.loanInformation.purpose,
        veteranStatus: this.loanInformation.veteranStatus,
        purposeOfRefinance: this.loanInformation.refinanceCase
          .purposeOfRefinance
      };
      let fundingFeeData: any = this.calculateFundingFee(data);
      if (fundingFeeData && fundingFeeData.fundingFee)
        loanAmount =
          parseFloat(loanAmount) + parseFloat(fundingFeeData.fundingFee);
    }
    let dpt = this.loanInformation.minDownPaymentType;
    let pv: any = parseFloat(this.loanInformation.propertyValue);
    let la: any = parseFloat(this.loanInformation.loanAmount);
    let monthlyPayment: any = 0;
    if (interestRate && loanAmount && termMonth) {
      interestRate = interestRate / 100 / 12;
      let newInterest = interestRate + 1;
      let numerator = Math.pow(newInterest, termMonth);
      let newValue = (numerator * interestRate) / (numerator - 1);
      let calculateValue = newValue * loanAmount;
      monthlyPayment = Math.round(calculateValue * 100) / 100;
    }
    if (dpt == "$") {
      this.loanInformation.minDownPayment = pv - la;
    } else {
      this.loanInformation.minDownPayment = ((pv - la) / pv) * 100;
    }
    this.loanInformation.mortgageMonthlyPayment = monthlyPayment;
    this.calculateLTVAndCLTV();
  }

  public calculateLTVAndCLTV() {
    let propertyValue = this.loanInformation.propertyValue;
    let loanAmount = this.loanInformation.loanAmount;
    if (propertyValue && loanAmount && loanAmount <= propertyValue) {
      this.loanInformation.LTV = Math.round((loanAmount / propertyValue) * 100);
      this.loanInformation.LTV = this.loanInformation.LTV.toFixed(2);
    } else this.loanInformation.CLTV = this.loanInformation.LTV = 0;
  }

  public async showDtiAndHousingRatioDetails() {
    this.$store.state.wemloLoader = true;
    try {
      let response = await Axios.post(
        BASE_API_URL + "los/getlosHeaderData",
        {
          loanTxnId: this.loanTxnId
        }
      );

      if (response.status == 200) {
        this.dtiAndHousingRatioDetails = response.data;
      }

      this.ShowDtiValue = true;
    } catch (error) {
      console.log(error);
    }
    this.$store.state.wemloLoader = false;
  }

  /********************************************************************************************************************************
   *    This Function used for set calculation values in LOS.
   */
  public async LosCommonFunction() {
    try {
      let response = await Axios.post(
        BASE_API_URL + "los/callAllLOSCommonFunction",
        { loanTxnId: this.loanTxnId });
    } catch (error) {
      console.log(error);
    }
  }

  public validateDocuments() {
    try {
      let uploadedDoc = this.documents.filter(d => d.fileHistory.length > 0);
      let NADoc = this.documents.filter(
        d => this.isNotApplicable(d.documentStatus)
      );
      let borToUpload = this.documents.filter(
        d => d.documentStatus == "Wemlo Assitance"
      );
      let hasAusFinding = this.ausFileId.fileHistory.length > 0 ? true : false;
      if (
        NADoc.length > 0 &&
        this.documents.length > 0 &&
        NADoc.length == this.documents.length
      ) {
        if (hasAusFinding) {
          this.showValidation = false;
          return false;
        }
      } else if (
        borToUpload.length > 0 &&
        this.documents.length > 0 &&
        borToUpload.length == this.documents.length
      ) {
        this.showValidation = false;
        return false;
      } else if (
        uploadedDoc.length > 0 &&
        this.documents.length > 0 &&
        uploadedDoc.length == this.documents.length
      ) {
        this.showValidation = false;
        return false;
      } else if (
        NADoc.length > 0 &&
        uploadedDoc.length > 0 &&
        NADoc.length <= uploadedDoc.length &&
        NADoc.length + uploadedDoc.length == this.documents.length
      ) {
        this.showValidation = false;
        return false;
      } else if (
        NADoc.length > 0 &&
        uploadedDoc.length > 0 &&
        uploadedDoc.length <= NADoc.length &&
        NADoc.length + uploadedDoc.length == this.documents.length
      ) {
        this.showValidation = false;
        return false;
      } else if (
        borToUpload.length > 0 &&
        uploadedDoc.length > 0 &&
        borToUpload.length <= uploadedDoc.length &&
        borToUpload.length + uploadedDoc.length == this.documents.length
      ) {
        this.showValidation = false;
        return false;
      } else if (
        borToUpload.length > 0 &&
        uploadedDoc.length > 0 &&
        uploadedDoc.length <= borToUpload.length &&
        borToUpload.length + uploadedDoc.length == this.documents.length
      ) {
        this.showValidation = false;
        return false;
      } else if (
        NADoc.length > 0 &&
        borToUpload.length > 0 &&
        NADoc.length <= borToUpload.length &&
        NADoc.length + borToUpload.length == this.documents.length
      ) {
        this.showValidation = false;
        return false;
      } else if (
        NADoc.length > 0 &&
        borToUpload.length > 0 &&
        borToUpload.length <= NADoc.length &&
        NADoc.length + borToUpload.length == this.documents.length
      ) {
        this.showValidation = false;
        return false;
      }
      
      let NonApprovedDocs = this.documents.filter(
        d => d.categoryType && d.documentStatus != "Not Applicable" 
      );

      NonApprovedDocs = NonApprovedDocs.filter(doc => {
        let status = doc.fileHistory && doc.fileHistory.length && doc.fileHistory[doc.fileHistory.length-1].status;
        let statustList = ['Uploaded', 'Approved']
        if(doc.fileHistory && !doc.fileHistory.length){
          return true;
        } else if(statustList.includes(status)){
          return false;
        }
      });

      if(!NonApprovedDocs.length){
        this.showValidation = false;
        return false;
      }

      return true;
    } catch (error) {
      console.log(error);
    }
  }

  public isNotApplicable(documentStatus) {
    return ["Not Applicable", "Not Applicable For Borrower"].includes(documentStatus);
  }

  public async showRequiredDocumentsList(){
     let allDocuments = this.documents;
     let docsToUpload = [];
     allDocuments.forEach(doc => {
       let status = doc.fileHistory && doc.fileHistory.length && doc.fileHistory[doc.fileHistory.length-1].status;
        let statustList = ['Uploaded', 'Approved']
         if(statustList.includes(status) || this.isNotApplicable(doc.documentStatus)) {
           return;
          }else{
            docsToUpload.push(doc);
         }
     });


    docsToUpload = docsToUpload.filter(doc => doc.categoryType);
    this.docsToUpload = _.groupBy(docsToUpload, 'categoryType');
    if(Object.keys(this.docsToUpload).length){
      this.showDocumentPopup()
    }
  }

public async showDocumentPopup() {
    try {
      this.documentLeftToUpload = this.documents.filter(
        d => {
           let status = d.fileHistory && d.fileHistory.length && d.fileHistory[d.fileHistory.length-1].status;
          let statustList = ['Uploaded', 'Approved']
          return d.documentStatus == "Required" || !statustList.includes(status)
        }
      );
      this.$modal.show("showLeftDocuments");
    } catch (error) {
      console.log(error);
    }
  }

  public async addNewSubcategory(category = null) {
    try {
      let response = await Axios.post(
        BASE_API_URL + "document/getBorrowerCoBorrowerName",
        { loanTxnId: this.loanTxnId });
      if (response.data && response.data.borrowerInfo.length > 0) {
        response.data.borrowerInfo.forEach(d => {
          let obj = {
            name: d.name.firstName + " " + d.name.lastName,
            borrowerId: d.borrowerId
          };
          this.borrowers.push(obj);
        });
        // let primaryBorrower = this.borrowers.find(d=>d.borrowerId == response.data.primaryBorrowerUserId);
        // this.borrowerName = [primaryBorrower];
        this.borrowerName = this.borrowers;
      }
      if (category) {
        this.newCategory = category;
        this.isCategoryFixed = true;
      }
      this.$modal.show("newCategoryModal");
    } catch (error) {
      console.log(error);
    }
  }

  // public  modalForDtiRatio(){
  //   try {
  //     this.$modal.show("modalForDtiRatio")
  //   } catch (error) {
  //     console.log(error);

  //   }
  // }
  /********************************************************************************
   *         Don't Remove Commented code it can be further use for POS            *
 
  // public selectPosBorrower() {
  //   if (this.borrowerData && this.borrowerDetails) {
  //     if (this.borrowerDetails.relationshipMapping.length == 1) {
  //       this.$router.push({
  //         path: this.$getCurrentUserTypePath("pos-questionnaire"),
  //         query: {
  //           loanTxnId: this.loanTxnId,
  //           borrowerId: this.borrowerData.borrowerInfo[
  //             this.borrowerDetails.relationshipMapping[0].borrowerIndex
  //           ].userId
  //         }
  //       });
  //     } else {
  //       this.openBorrowerSelectionModal = true;
  //     }
  //   }
  // }
  ********************************************************************************/

  public async triggerValidate(){

    this.losRequiredList = await this.checkLosFormCompleted();
    if (this.losRequiredList) {
      this.isLosFieldMissing = true;
    }

    /**
     * START:: DEV AUTOMATE SAVE WARNING DATA
     
    let devAutosaveGeneralTabPayload = {"loanTxnId":this.$route.query.id,"loanInformation":{"AUS":null,"propertyValue":340000,"estimatedPropertyValue":0,"waive":null,"loanAmount":300000,"productType":{"ppeValue":"1","name":"Conforming","ediValue":"01","mismoValue":"Conforming","value":"Conventional"},"propertyType":{"ppeValue":"1","name":"Single Family Attached","ediValue":"02","mismoValue":"SingleFamilyAttached","value":"Single Family Attached"},"occupancy":{"ppeValue":"1","name":"Owner Occupied","ediValue":"1","mismoValue":"PrimaryResidence","value":"Primary Residence"},"amortizationType":{"ppeValue":"1","name":"Fixed","ediValue":"05","mismoValue":"Fixed","value":"Fixed Rate"},"purpose":{"ppeValue":"1","name":"Purchase","ediValue":"16","mismoValue":"Purchase","value":"Purchase"},"term":{"ppeValue":"5","name":"30 Years","ediValue":"","mismoValue":"30","value":360},"escrows":null,"doctype":null,"prepayPenalty":null,"investorOptions":null,"state":{"name":"","code":""},"cashout":0,"ppeRate":4.25,"loansifterPrice":0,"wemloPrice":0,"loansifterDiscPremCommission":0,"wemloDiscPremCommission":0,"loanNumber":null,"impounds":"true","tridApplicationDate":"2020-10-30T09:45:18.071Z","loanVersion":"V2","_id":"5f9be0abc5da1e8a9dd118af","lenderId":"","lenderName":"","lenderMortgageeClause":"","price":0,"rate":4.25,"compensationType":"","compensation":null,"closingDate":null,"rateType":null,"matchLenderToBpc":null,"LTV":"88.24","CLTV":0,"FICO":null,"DTI":18.08,"noFICO":false,"lockDays":30,"nonOccupantCoBorrower":false,"interestRateOnly":true,"feeInPrice":false,"homePath":"false","LPMI":false,"wemloProcessingFee":true,"zipCode":"91502","county":"","minDownPayment":40000,"minDownPaymentType":"$","subjectPropertyAddress":{"street":null,"unit":null,"city":null,"state":null,"zip":null,"county":null,"country":null},"interestRate":4.25,"loanPurpose":{"ppeValue":"1","name":"Purchase","ediValue":"16","mismoValue":"Purchase","value":"Purchase"},"propertyAddress":{"address":{"street":"10655 Birch St","city":"Burbank","state":{"code":"CA","name":"California"},"zip":"91502","county":"Los Angeles County","country":"United States"},"numberOfUnits":"1","propertyValue":340000,"propertyAddressSameAsCurrentAddress":false},"refinanceCase":{"yearAcquired":null,"purposeOfRefinance":null,"toBeMade":null,"describeImprovements":null,"amountExistingLiens":0},"veteranStatus":null,"createdOn":"2020-10-30T09:45:15.836Z","borrowerName":"Ken Customer1","status":"Prospect","mortgageMonthlyPayment":1475.82,"havePowerOfAttorney":true,"isFirstTimeHomeBuyer":true},"financialInfo":[{"address":{"street":null,"unit":null,"city":null,"state":null,"zip":null,"county":null,"country":null},"mortgageLoans":[],"propertyValue":0,"status":null,"propertyType":null,"currentProperty":false,"subjectProperty":false,"maintenanceExpenseAmount":0,"rentalIncomeGrossAmount":0,"rentalIncomeNetAmount":0,"numberOfUnits":null,"reoSameAsSubjectProperty":false,"reoSameAsCurrnetAddress":false}]}
    let devAutosaveDeclarationsTabPayload = {"loanTxnId": this.$route.query.id,"declarationData":[{"propertyType":{"isPrimaryResidence":"true","ownershipInPast":"false","typeOfProperty":null},"borrowedForDownpayment":{"ediValue":"98","mismoValue":"Part of DownPayment","hasBorrowed":"false","typeOfDownPayment":null,"explanation":null},"everTransferOftitleDuetoLoan":{"ediValue":"95","mismoValue":"Obligated on a loan foreclosed","transfer":"false","explanation":null},"childAlimonySeperateSupport":{"ediValue":"97","mismoValue":"Child Support Maintanance","isChildAlimonySeperateSupport":"false","explanation":null},"coSigner":{"ediValue":"99","mismoValue":"Co-Maker or Endorser on a note","isCoSigner":"false","explanation":null},"outstandingJudgements":{"ediValue":"91","mismoValue":"Outstanding Judgement","hasOutstandingJudgements":"false","explanation":null},"federalDebt":{"ediValue":"96","mismoValue":"Delinquency or Default","hasFederalDebt":"false","explanation":null,"delinquencyDate":null},"partyInLawsuit":{"ediValue":"94","mismoValue":"Party to Lawsuit","isPartyInLawsuit":"false","explanation":null},"conveyedTitleToAnyProperty":{"ediValue":"93","mismoValue":"Foreclosed Property in the past 7 years","haveConveyedTitleToAnyProperty":"false","explanation":null},"bankruptcyDeclaration":{"haveDeclaredBankruptcy":"false","ediValue":"92","mismoValue":"DeclaredBankruptcyInPast7Years","typesOfBankruptcy":[]},"affiliationSellerProperty":{"hasAffiliationSellerProperty":"false","hasGiftedTransaction":null},"isUSCitizen":null,"isPermanentResidentAlien":null,"applyForLoanInAnotherProperty":null,"applyForOtherCredit":null,"isSubjectToLien":null,"haveCompletedPreForeClosureSale":null,"hadForeClosedProperty":null,"isMortgageLoan":"false","isCreditCard":"false","isMortgageLien":"false","outstandingMortgage":"false","_id":"5f9be0ab29bcb801b64d90ce","userId":"5f9be0ab29bcb801b64d90a6"}],"borrowerInfo":[{"personalInfo":{"maritalStatus":{"status":{"name":"Unmarried","ediValue":"U","mismoValue":"Unmarried","value":"Unmarried"},"unMarriedStatus":null},"citizenship":{"name":"U.S. Citizen","value":"U.S. Citizen","mismoValue":"USCitizen","ediValue":"01"}},"proposedCombinedMonthlyExpense":{"hazardInsurance":{"ediValue":"01","monthlyExpense":75},"realEstateTaxes":{"ediValue":"14","monthlyExpense":165},"mortgageInsurance":{"ediValue":"02","monthlyExpense":0},"homeOwnerAssociationDue":{"ediValue":"06","monthlyExpense":365},"other":{"ediValue":"23","monthlyExpense":0},"firstMortgagePandI":{"ediValue":"26","monthlyExpense":1475.82},"otherMortgagePandI":{"ediValue":"22","monthlyExpense":0}},"otherLiabilitiesAndExpenses":[{"name":{"name":"Other","ediValue":"EE","mismoValue":"Other","value":"Other"},"monthsLeftToPay":null,"_id":"5f9be0ab29bcb801b64d90cc","monthlyPayment":0,"proposedMonthlyPayment":0},{"name":{"name":"Other","ediValue":"EE","mismoValue":"Other","value":"Other"},"monthsLeftToPay":null,"_id":"5f9be0ab29bcb801b64d90cb","monthlyPayment":0,"proposedMonthlyPayment":0}],"userId":"5f9be0ab29bcb801b64d90a6"}],"borrowerIndex":0}
   
    if(this.currentEnvironment == 'development'){
      await Axios.post(
        BASE_API_URL + "los/updateGeneralData",
        devAutosaveGeneralTabPayload);

      await Axios.post(
        BASE_API_URL + "los/saveDeclaration",
        devAutosaveDeclarationsTabPayload);

    }
    
    /**
     * END:: DEV AUTOMATE SAVE WARNING DATA
     */
  }

  public async getSettingMandatoryBrokerOnboarding(){
    try{
      this.$store.state.wemloLoader = true;
      let response = await Axios.post(
        BASE_API_URL + "broker/getWemloSettingDetails",
        {
          userId: this.$userId,
        });
        if(response.status == 200) {
          this.isMandatoryBrokerOnboarding = response.data.statusMandatoryBrokerOnboarding || false;
        }
    }catch(error){
      console.log(error);
    }
    this.$store.state.wemloLoader = false;
  }

  async mounted() {
    this.loanTxnId = this.$route.query.id;
    this.triggerValidate();
    this.LosCommonFunction();
    await this.fetchBorrwoerInfo();
    await this.getBorrowersDocumentsDetails();
    await this.getBorrowerLoanDocuments();
    await this.getSettingMandatoryBrokerOnboarding();
    this.calculator();
    this.getBrokerDetails();
  }
}
